<script setup>
import {CContainer} from "@coreui/vue/dist/esm/components/grid/index.js";
import { AppHeader, AppSidebar } from "~/components/layout";
import ToastContainer from "~/components/ui/ToastContainer.vue";
</script>

<template>
  <div>
    <AppSidebar />
      <div class="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <div class="body flex-grow-1">
          <CContainer class="px-4" fluid>
            <NuxtPage />
          </CContainer>
        </div>
      </div>
    <ToastContainer />
  </div>
</template>